(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["yotpo-review"] && !Shopify.designMode) return;
  try {
    function yotpoInit() {
    if (window.yotpoWidgetsContainer?.initWidgets) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  // Watches a widget until Yotpo finishes rendering, then hides it if it has 0 reviews.
  // We observe the subtree for any star element to appear — only then we decide,
  // avoiding the race condition where data-yotpo-element-loaded is set before stars are in the DOM.
  function watchAndHideEmptyWidget(widget) {
    function checkAndHide() {
      const hasReviews = widget.querySelector('.yotpo-sr-star-full, .yotpo-sr-star-half');
      widget.style.display = hasReviews ? '' : 'none';
    }

    // If Yotpo already rendered stars, act immediately.
    if (widget.querySelector('.yotpo-sr-star-full, .yotpo-sr-star-half, .yotpo-sr-star-empty')) {
      checkAndHide();
      return;
    }

    // Otherwise, wait for any star to appear in the subtree.
    const observer = new MutationObserver((_mutations, obs) => {
      if (widget.querySelector('.yotpo-sr-star-full, .yotpo-sr-star-half, .yotpo-sr-star-empty')) {
        obs.disconnect();
        checkAndHide();
      }
    });
    observer.observe(widget, { childList: true, subtree: true });
  }

  // Applies hide-empty logic to all widgets that have the flag enabled.
  function applyHideEmpty() {
    document.querySelectorAll('yotpo-review-widget[data-hide-empty="true"]').forEach(watchAndHideEmptyWidget);
  }

  // Handles initial load and infinite-scroll appends.
  if (!customElements.get('yotpo-review-widget')) {
    customElements.define(
      'yotpo-review-widget',
      class YotpoReviewWidget extends HTMLElement {
        connectedCallback() {
          setTimeout(yotpoInit, 150);
          if (this.dataset.hideEmpty === 'true') {
            watchAndHideEmptyWidget(this);
          }
        }
      }
    );
  }

  // Handles filter updates: filter:update fires before the async morph,
  // so we wait 700ms for the DOM to settle before re-initializing.
  if (!window.__yotpoReinitActive) {
    window.__yotpoReinitActive = true;
    document.addEventListener('filter:update', () => {
      setTimeout(() => {
        yotpoInit();
        applyHideEmpty();
      }, 700);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
